(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-box"] && !Shopify.designMode) return;
  try {
    class BuyBoxTotal extends HTMLElement {
    connectedCallback() {
      this.unitPrice = parseInt(this.dataset.unitPrice, 10);
      this.currency = this.dataset.currency;
      this.input = document.getElementById(this.dataset.quantityInput);

      if (Number.isNaN(this.unitPrice) || !this.input) return;

      try {
        this.formatter = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: this.currency || 'BRL',
        });
      } catch (error) {
        return;
      }

      this.onChange = this.onChange.bind(this);
      this.input.addEventListener('change', this.onChange);
      this.input.addEventListener('input', this.onChange);
      this.onChange();
    }

    disconnectedCallback() {
      if (!this.input) return;
      this.input.removeEventListener('change', this.onChange);
      this.input.removeEventListener('input', this.onChange);
    }

    onChange() {
      const quantity = Math.max(parseInt(this.input.value, 10) || 1, 1);
      this.textContent = this.formatter.format((this.unitPrice * quantity) / 100);
    }
  }

  if (!customElements.get('buy-box-total')) {
    customElements.define('buy-box-total', BuyBoxTotal);
  }
  } catch(e) { console.error(e); }
})();

})();
